const translations = {
    acres: 'Acres',
    fieldApplication: 'Field Application',
    hours: 'Hours',
    perAcre: 'Per Acre',
    perHour: 'Per Hour'
};

export default translations;
